import { render, staticRenderFns } from "./WorkshopFileErrorsTable.vue?vue&type=template&id=05973f36"
import script from "./WorkshopFileErrorsTable.vue?vue&type=script&lang=ts"
export * from "./WorkshopFileErrorsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports